export default __webpack_public_path__ + "static/media/manager-badge-grey.62cf22da.svg";